import { render, staticRenderFns } from "./map-city.vue?vue&type=template&id=5c679472&scoped=true&"
import script from "./map-city.vue?vue&type=script&lang=js&"
export * from "./map-city.vue?vue&type=script&lang=js&"
import style0 from "./map-city.vue?vue&type=style&index=0&id=5c679472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c679472",
  null
  
)

export default component.exports